import _ from 'lodash';

import Communicator from 'models/communicator';
import ConversationItem from 'models/conversation_item';
import ConversationMessage, { MessageStatus } from 'models/conversation_message';
import htmlToText from 'models//conversation_item/html_to_text';
import MessageContentTypeFile from 'models/message_content_type_file';
import MessageContentTypeText from 'models/message_content_type_text';

export default function createConversationMessage(
  agentProfile,
  attachments,
  messageContent,
  conversationId,
  customerId,
  snippetIds,
  relatedSnippetIds
) {
  let content = getContent();
  let channel = messageContent.channel;
  let companyAddress = messageContent.companyAddress;
  let customerAddress = messageContent.customerAddress;

  return ConversationItem.create({
    conversationId,
    content: ConversationMessage.create({
      channel,
      companyAddress,
      content,
      customerAddress,
      status: { value: MessageStatus.NEW },
    }),
    customerId,
    initiator: {
      id: agentProfile.id,
      type: Communicator.AGENT,
    },
    snippetIds,
    relatedSnippetIds,
  });

  // attachment support coming soon - for now we default to text
  function getContent() {
    let body = messageContent.bodyHtml;
    let typeText = MessageContentTypeText.create({
      body: htmlToText(body),
      bodyHtml: body,
    });

    let typeFile = MessageContentTypeFile.create({
      text: htmlToText(body),
      bodyHtml: body,
      files: attachments,
    });
    return _.size(attachments) > 1 ? typeFile : typeText;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/domain/models/create_conversation_message.js